export function featureInSection(sections, section, variableId) {
	let featuresWithAssignedSections = [];
	if (section.features === null) {
		sections.forEach(s => {
			featuresWithAssignedSections = Array.from(new Set(featuresWithAssignedSections.concat(s.features)));
		});
		return !featuresWithAssignedSections.includes(variableId);
	} else {
		return section.features?.includes(variableId);
	}

}
